import {ListItemText, MenuItem} from '@mui/material'
import {React} from 'common'
import {MenuIconByType} from 'constants/topMenu'

const MainMenuItem = ({onClick, type, text}) => {
    return (
        <MenuItem sx={{px: 2.5, py: 0.5}} onClick={onClick}>
            <ListItemText primary={text} sx={{px: 1}} />
            {MenuIconByType?.[type]}
        </MenuItem>
    )
}

export default MainMenuItem
